exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unbind-box[data-v-97dff39a]{height:600px}.unbind-box>div[data-v-97dff39a]{margin-top:220px}.unbind-box>div>p[data-v-97dff39a]{margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-97dff39a","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/www/newcode/platform-admin/src/style/theme.scss","/data/www/newcode/platform-admin/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/base/empty/unbind.vue
// module id = 863
// module chunks = 30